// Util simples para manipular cookies com JSON

export function setJsonCookie(name, value, days = 365) {
  try {
    const json = JSON.stringify(value);
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `; expires=${date.toUTCString()}`;
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(json)}${expires}; path=/`;
  } catch (e) {
    // Se falhar serialização, não grava
  }
}

export function getJsonCookie(name, defaultValue = null) {
  const key = `${encodeURIComponent(name)}=`;
  const parts = document.cookie ? document.cookie.split(';') : [];
  for (let i = 0; i < parts.length; i += 1) {
    let c = parts[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(key) === 0) {
      const raw = decodeURIComponent(c.substring(key.length, c.length));
      try {
        return JSON.parse(raw);
      } catch (e) {
        return defaultValue;
      }
    }
  }
  return defaultValue;
}


